<template>
    <div>
        <card-header title="New Session Track" icon="fa-plus"/>

        <card-body>
            <track-form :track="track"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!track.title"
                    ><i class="fas fa-plus mr-2"></i>New Track
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";

    import CourseForm from "@/cards/courses/CourseForm";

    import {client as http} from "@/http_client";
    import TrackForm from "./TrackForm";

    import moment from "moment";

    export default {
        components: {TrackForm, CardHeader, CardToolbar, CardBody, CardFooter, CourseForm},
        props: ['card', 'props'],
        data() {
            return {
                conference: {},
                track: {}
            };
        },
        methods: {
            submit: function() {
                this.$emit('loading', true);
                http.post('conferences/' + this.props.confId + '/tracks', {conference_id: this.props.confId, ...this.track}, {force: true}).then(response => {
                    this.$reloadCard('conf-tracks');
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the track.');
                    this.$emit('loading', false);
                });
            },
            // loadConference: function(force) {
            //     this.$emit('loading', true);
            //     http.get('conferences/' + this.props.confId, {force}).then(response => {
            //         response.data.start_at = moment(response.data.start_at).toDate();
            //         response.data.end_at = moment(response.data.end_at).toDate();
            //         this.conference = response.data;
            //
            //         this.$emit('loading', false);
            //     }).catch(err => {
            //
            //     });
            // }
        },
        mounted() {
            // this.loadConference();
        }
    };
</script>
